import type { ComponentProps } from 'react';
import React from 'react';

import { token } from '@atlaskit/tokens';

/**
 * WARNING: Be careful about importing other dependencies in this file because the component is exported directly in index
 */
export const PageTreeExporterIcon = (props: ComponentProps<'svg'>): React.JSX.Element => (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect width="40" height="40" fill={token('color.icon.inverse')} />
		<rect width="40" height="40" rx="3" fill={token('color.background.accent.gray.subtlest')} />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29.7229 7.85542C30.4615 7.85542 31.0602 8.45417 31.0602 9.19277V13.0241C31.0602 13.7627 30.4615 14.3614 29.7229 14.3614H10.0602C9.32164 14.3614 8.72289 13.7627 8.72289 13.0241V9.19277C8.72289 8.45417 9.32164 7.85542 10.0602 7.85542H29.7229Z"
			fill={token('color.icon')}
			fillOpacity="0.95"
		/>
		<path
			opacity="0.5"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.8664 11.0627C20.8424 10.545 20.4151 10.1327 19.8916 10.1327C19.3526 10.1327 18.9157 10.5696 18.9157 11.1086V19.0243H14.5783L14.5087 19.0249C12.5646 19.062 11 20.6496 11 22.6026V28.8917L11.0011 28.9377C11.025 29.4553 11.4523 29.8676 11.9759 29.8676C12.5149 29.8676 12.9518 29.4307 12.9518 28.8917V22.6026L12.9526 22.5499C12.9804 21.676 13.6976 20.9761 14.5783 20.9761H18.9157V28.8917L18.9167 28.9377C18.9407 29.4553 19.368 29.8676 19.8916 29.8676C20.4305 29.8676 20.8675 29.4307 20.8675 28.8917V20.9761H25.2048L25.2575 20.9769C26.1314 21.0047 26.8313 21.7219 26.8313 22.6026V28.8917L26.8324 28.9377C26.8564 29.4553 27.2836 29.8676 27.8072 29.8676C28.3462 29.8676 28.7831 29.4307 28.7831 28.8917V22.6026L28.7825 22.533C28.7454 20.5888 27.1578 19.0243 25.2048 19.0243H20.8675V11.1086L20.8664 11.0627Z"
			fill={token('color.icon')}
			fillOpacity="0.95"
		/>
		<rect
			x="8.72289"
			y="25.6386"
			width="6.50602"
			height="6.50603"
			rx="1.33735"
			fill={token('color.icon')}
			fillOpacity="0.95"
		/>
		<rect
			x="24.5542"
			y="25.6386"
			width="6.50602"
			height="6.50603"
			rx="1.33735"
			fill={token('color.icon')}
			fillOpacity="0.95"
		/>
		<rect
			x="16.6385"
			y="25.6386"
			width="6.50602"
			height="6.50603"
			rx="1.33735"
			fill={token('color.icon')}
			fillOpacity="0.95"
		/>
	</svg>
);
